export function isValidGeoJsonMap(value: unknown): boolean {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const features = (value as { features?: unknown }).features;
    return Array.isArray(features) && features.length > 0;
}

export function normalizeCasteOverallRows(resource: unknown): unknown[] | null {
    if (!resource || typeof resource !== "object" || Array.isArray(resource)) return null;
    const overall = (resource as Record<string, unknown>).overall;
    return Array.isArray(overall) ? overall : null;
}
